<template>
  <div>
    <label class="h-0 opacity-0 transition-all duration-200">
      <span v-if="focused || inputValue">{{ label }}</span>
    </label>
    <div class="relative cursor-pointer">
      <input
        type="date"
        :placeholder="computedPlaceholder"
        @input="emitValue(inputValue)"
        v-model="inputValue"
        :required="required"
        @focus="setFocused(true)"
        @blur="setFocused(false)"
        :class="{ required: required, 'border-primary-500': inputValue }"
        :disabled="disabled"
        @keyup.enter="emitEnter"
        :min="minVar"
        :max="maxVar"
      />
      <div
        class="absolute inset-0 items-center border border-gray-500 rounded-sm px-2 py-2 bg-transparent pointer-events-none"
      >{{ inputValue ? momentFormat(inputValue, "DD.MM.YYYY") : computedPlaceholder }}</div>
    </div>

    <transition name="fade">
      <div v-if="touched && validations">
        <div class="h-0 mb-0 opacity-0 transition-all duration-200 validations">
          <validation
            v-for="(validation, index) in validations"
            :validation="validation"
            :input="inputValue"
            :key="index"
            :position="index"
            :focused="focused"
          />
        </div>
      </div>
    </transition>
  </div>
</template>

<script>
import DateMixin from "@/mixins/DateMixin";

const Validation = require("@/modules/input/components/Validation.vue").default;
const InputBase = require("@/modules/input/components/InputBase.vue").default;

export default {
  name: "InputText",
  mixins: [DateMixin],
  data() {
    return {
      minVar: null,
      maxVar: null
    };
  },
  extends: InputBase,
  props: {
    min: {
      type: Date,
      default: null
    },
    max: {
      type: Date,
      default: null
    }
  },
  components: {
    Validation
  },
  methods: {
    emitEnter() {
      this.$emit("enter-key");
    }
  },
  computed: {},
  created() {
    if (this.required) {
      this.validations.unshift({ validation: "required" });
    }
    if (this.min) {
      this.minVar = this.momentFormat(this.min, "YYYY-MM-DD");
    }
    if (this.max) {
      this.maxVar = this.momentFormat(this.max, "YYYY-MM-DD");
    }
  },
  watch: {}
};
</script>

<style scoped>
label {
  &:not(:empty) {
    @apply h-4 opacity-100;
  }
}

.validations {
  span + span:before {
    content: ", ";
  }
  &:not(:empty) {
    @apply h-4 mb-1 opacity-100;
  }
}
.required {
  @apply pr-8;
  background-image: url("data:image/svg+xml;utf8,<svg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 12 12' width='.6rem'><path d='M5.4,1.6H7.1V5.1l3.3-1.2L11,5.4,7.6,6.6,9.7,9.4l-1.3.9L6.3,7.4l-2,2.9L2.9,9.4l2-2.8L1.6,5.4l.6-1.5L5.4,5.1Z' /></svg>");
  background-repeat: no-repeat;
  background-position: right 0.8rem center;
  &::placeholder {
    @apply text-gray-800;
  }
}
</style>
